import { promiseRequest } from '../util/promiseRequest'
import https from 'https';
import http from 'http';

export const sendMessage = async (hostname: string, path: string, channel: string, text: string, extraOptions?: https.RequestOptions) => {
  const postData = {
    text,
    channel,
  }
  const options = {
    method: 'POST',
    hostname,
    path,
    headers: {
      'Content-Type': 'application/json',
    },
    ...extraOptions,
  }
  const requestFn = (req: http.ClientRequest) => {
    req.write(JSON.stringify(postData))
  }

  return await promiseRequest(options, requestFn)

}